
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grassroots-leadership-and-capacity",
      function () {
        return require("private-next-pages/grassroots-leadership-and-capacity.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grassroots-leadership-and-capacity"])
      });
    }
  